// T3-B PR 4 (2026-05-12) / PR 4-bis (2026-05-12):
//   template_motifs CRUD API クライアント (omikuji-api PR #117 / #118)。
//   auth: ADMIN only。

import ApiService from './ApiService';

export default class TemplateMotifApi extends ApiService {
    // GET /system/template-motifs?template_set_id=&include_sponsor_disabled=&include_inactive=
    list(payload?: {
        template_set_id?: number | string,
        include_sponsor_disabled?: 0 | 1,
        include_inactive?: 0 | 1
    }) {
        return this.get('template-motifs', payload);
    }

    // GET /system/template-motifs/:id
    getById(id: string | number) {
        return this.get(`template-motifs/${id}`);
    }

    // POST /system/motif-template-sets/:template_set_id/motifs
    create(payload: { template_set_id: string | number, data: any }) {
        const { template_set_id, data } = payload;
        return this.post(`motif-template-sets/${template_set_id}/motifs`, data);
    }

    // PUT /system/template-motifs/:id
    update(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`template-motifs/${id}`, data);
    }

    // DELETE /system/template-motifs/:id
    remove(id: string | number) {
        return this.delete(`template-motifs/${id}`);
    }
}
